import { render, staticRenderFns } from "./LoansLimitModal.vue?vue&type=template&id=0d735805&scoped=true&"
import script from "./LoansLimitModal.vue?vue&type=script&lang=js&"
export * from "./LoansLimitModal.vue?vue&type=script&lang=js&"
import style0 from "./LoansLimitModal.vue?vue&type=style&index=0&id=0d735805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d735805",
  null
  
)

export default component.exports